export enum COMMENT_RESOURCE_TYPES {
	MEDIA = 'Media',
	TAG = 'Tag',
	SYNC_EVENT = 'PlayerTimeSyncEvent'
}
